import styled from "styled-components";

const Title = styled.span`
  font: 40px "Euclid Circular A", sans-serif;
  font-weight: 800;
  line-height: 48px;
  padding-top: 32px;
  color: #050505;
  display: inline-block;

  @media only screen and (max-width: 768px) {
    font: 32px "Euclid Circular A", sans-serif;
    font-weight: 800;
    line-height: 40px;
  }
`;

const Header = styled.span`
  font: 24px "Euclid Circular A", sans-serif;
  font-weight: 800;
  line-height: 32px;
  padding-top: 24px;
  color: #A39C99;
  display: inline-block;

  @media only screen and (max-width: 768px) {
    font: 20px "Euclid Circular A", sans-serif;
    font-weight: 800;
    line-height: 24px;
  }
`;

const Subtitle = styled.span`
  font: 32px "Euclid Circular A", sans-serif;
  font-weight: 800;
  line-height: 48px;
  padding-top: 24px;
  color: #050505;
  display: inline-block;

  @media only screen and (max-width: 768px) {
    font: 24px "Euclid Circular A", sans-serif;
    font-weight: 800;
    line-height: 32px;
  }
`;

const Body = styled.span`
  font: 16px "Euclid Circular A", sans-serif;
  font-weight: 500;
  line-height: 24px;
  padding-top: 16px;
  color: #A39C99;
  display: inline-block;

  @media only screen and (max-width: 768px) {
    font: 16px "Euclid Circular A", sans-serif;
    font-weight: 500;
    line-height: 22px;
  }
`;

const Paragraph = styled.p`
  font: 18px "Euclid Circular A", sans-serif;
  font-weight: 400;
  line-height: 28px;
  margin-top: 32px;
  margin-bottom: 0;
  color: #050505;
  display: inline-block;

  @media only screen and (max-width: 768px) {
    font: 16px "Euclid Circular A", sans-serif;
    font-weight: 400;
    line-height: 24px;
  }
`;

const ButtonTitle = styled.span`
  font: 16px "Euclid Circular A", sans-serif;
  font-weight: 800;
  line-height: 24px;
  color: #050505;
  padding-right: 8px;

  @media only screen and (max-width: 768px) {
    font: 16px "Euclid Circular A", sans-serif;
    font-weight: 800;
    line-height: 24px;
  }
`;

const ActionButtonTitle = styled(ButtonTitle)`
  color: #FAF8F7;
`;

const IconLessButtonTitle = styled(ButtonTitle)`
  color: #FAF8F7;
  padding-left: 8px;
`;

const ColoredActionButtonTitle = styled(ButtonTitle)`
  color: #FE6A33;
`;

const CenteredColoredActionButtonTitle = styled(ColoredActionButtonTitle)`
  padding-right: 32px;
  padding-left: 32px;
`;


const FooterButtonTitle = styled(ButtonTitle)`
  font: 14px "Euclid Circular A", sans-serif;
  font-weight: 500;
  color: #A39C99;
  padding-right: 4px;
  padding-left: 4px;
`;

const WhiteFooterButtonTitle = styled(FooterButtonTitle)`
  color: #FAF8F7;
`;

export { Title, Subtitle, Header, Body, Paragraph, ButtonTitle, ActionButtonTitle, ColoredActionButtonTitle, CenteredColoredActionButtonTitle, FooterButtonTitle, IconLessButtonTitle, WhiteFooterButtonTitle };
